<template>
  <div>
    <div style="display: flex;justify-content: space-between">
      <div>Other Charge</div>
      <div v-if="this.isEdit" class="triggers" style="display: flex;justify-content: flex-end">
        <el-button no="Add" type="primary" @click="addChargeHandler">{{ $t("CargoMsg.Cargo_Add") }}</el-button>
        <el-button no="Delete" type="primary" @click="delChargeHandler">{{ $t("CargoMsg.Cargo_Delete") }}</el-button>
      </div>
    </div>
    <div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :show-side-bar="false"
        :row-data="rowData"
        style="height: 100%"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import { OtherCharge } from '@/class/model/booking/OtherCharge'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicData, cacheKeys } from '@/utils/basicDataCache'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import * as NumberUtils from '@/utils/NumberUtils'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'

export default {
  name: 'OtherChargeGrid',
  components: {
  },
  props: {
    cargoDoc: { type: Object, required: true },
    action: { type: String, default: 'look' },
    job: { type: Object }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        context: {
          componentParent: this
        },
        suppressRowClickSelection: false,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridSelectEditor
        }
      },
      gridParams: {},
      gridApi: null,
      selectedRowIndex: -1
    }
  },
  computed: {
    selectedRow() {
      return this.rowData[this.selectedRowIndex]
    },
    rowData() {
      return this.cargoDoc.otherCharge ? this.cargoDoc.otherCharge.filter(p => !p.deleted) : []
    },
    isEdit() {
      return this.action !== 'look'
    },
    columnDefs() {
      return [
        {
          headerName: 'Charge',
          field: 'chargeItem',
          colId: 'chargeItem',
          suppressMenu: true,
          width: 200,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_OtherChargeItem,
              headers: ['code'],
              fields: ['chargeItemCode'],
              tagName: 'chargeItemCode',
              filterable: true,
              filterType: 'global'
            }
          },
          // valueFormatter: params => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OtherChargeItem, 'chargeItemCode', params.value, 'chineseName')
          // },
          onCellValueChanged: params => {
            this.chargeItemChange(params)
          }
        },
        {
          headerName: 'Unit Rate',
          field: 'unitRate',
          colId: 'unitRate',
          suppressMenu: true,
          width: 130,
          // 是否开启编辑
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return NumberUtils.roundHalfUp(params.value, 2) || 0
          },
          // 值变化事件
          onCellValueChanged: (params) => {
            this.unitRateChange(params)
          }
        },
        {
          headerName: 'Measure',
          field: 'measure',
          colId: 'measure',
          suppressMenu: true,
          width: 130,
          editable: this.isEdit,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: AirExportConstants.OTHER_CHARGE_ITEM_MEASURE_AI,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return ColumnUtils.otherChargeItemMeasureLabFun(params.value)
          },
          onCellValueChanged: (params) => {
            this.measureChange(params)
          }
        },
        {
          headerName: 'Amount',
          field: 'amount',
          colId: 'amount',
          suppressMenu: true,
          width: 150,
          // 是否开启编辑
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 2,
              max: 999999999,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          valueFormatter: params => {
            return (NumberUtils.roundHalfUp(params.value, 2) || 0).toFixed(2)
          },
          onCellValueChanged: params => {
            this.amountChange(params)
          }
        },
        {
          headerName: 'Remark',
          field: 'remark',
          suppressMenu: true,
          width: 150,
          // 是否开启编辑
          editable: this.isEdit,
          // 单元格绑定编辑组件
          cellEditor: 'CargoAgGridCommonInputEditor',
          // 编辑组件入参
          cellEditorParams: {
            isNumber: false,
            isUppercase: true
          }
        }
      ]
    }
  },
  watch: {
    'cargoDoc.weight': {
      handler(newValue, oldValue) {
        if (this.gridApi) {
          const nodes = this.gridApi.rowModel.rowsToDisplay
          for (const node of nodes) {
            if (node.data.measure === 'wt') {
              this.measureChange({ node, newValue, oldValue, data: node.data })
            }
          }
        }
      }
    },
    'cargoDoc.cWeight': {
      handler(newValue, oldValue) {
        if (this.gridApi) {
          const nodes = this.gridApi.rowModel.rowsToDisplay
          for (const node of nodes) {
            if (node.data.measure === 'chargeWeight') {
              this.measureChange({ node, newValue, oldValue, data: node.data })
            }
          }
        }
      }
    }
  },
  methods: {
    addChargeHandler() {
      const oc = new OtherCharge().fillDefaultValue().getData()
      oc.airCargoDocUuid = this.cargoDoc.uuid
      oc.minAmount = 0.0
      oc.chargeId = this.rowData.length
      let otherCharges = this.cargoDoc.otherCharge
      if (!otherCharges || otherCharges.length === 0) {
        otherCharges = []
      }
      otherCharges.push(oc)
      this.cargoDoc.otherCharge = otherCharges
    },
    delChargeHandler() {
      if (this.selectedRow) {
        if (this.selectedRow.uuid) {
          for (const item of this.cargoDoc.otherCharge) {
            if (item.uuid && item.uuid === this.selectedRow.uuid) {
              item.deleted = true
            }
          }
        } else {
          const index = this.cargoDoc.otherCharge.findIndex(p => p === this.selectedRow)
          if (index > -1) {
            this.cargoDoc.otherCharge.splice(index, 1)
          }
        }
        AirExportUtils.refreshCargoDoc(this.cargoDoc, this.rowData)
      } else {
        this.$message.warning(this.$t('queryJob.PleaseSelectAFee'))
        return
      }
    },
    async chargeItemChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue === oldValue) return
      const chargeItems = await getSpecificBasicData(cacheKeys.basic_data_OtherChargeItem)
      if (chargeItems && chargeItems.length > 0) {
        const chargeItem = chargeItems.find(item => {
          return item.chargeItemCode === newValue
        })
        if (chargeItem) {
          node.setDataValue('measure', chargeItem.measure)
          node.setDataValue('unitRate', chargeItem.defaultApPrice)
          AirExportUtils.refreshMAWBAmount(this.job, this.cargoDoc, params.data)
          node.setDataValue('amount', params.data.amount)
          AirExportUtils.refreshCargoDoc(this.cargoDoc, this.rowData)
        }
      }
    },
    unitRateChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue === oldValue) return
      AirExportUtils.refreshMAWBAmount(this.job, this.cargoDoc, params.data)
      node.setDataValue('amount', params.data.amount)
      AirExportUtils.refreshCargoDoc(this.cargoDoc, this.rowData)
    },
    measureChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue === oldValue) return
      AirExportUtils.refreshMAWBAmount(this.job, this.cargoDoc, params.data)
      node.setDataValue('amount', params.data.amount)
      AirExportUtils.refreshCargoDoc(this.cargoDoc, this.rowData)
    },
    amountChange(params) {
      const { node, newValue, oldValue } = params
      if (newValue === oldValue) return
      node.setDataValue('amount', newValue)
      AirExportUtils.refreshCargoDoc(this.cargoDoc, this.rowData)
    }
  }
}
</script>

<style scoped>

</style>
